import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createCheckTypes, editCheckTypesById } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getFirstFormError, getResponseError, setFormError } from '../../../utils/utils';
import CheckTypesDTO from '../../../dto/CheckTypesDTO';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';
import {
  CHECK_TYPE_APPLY_TO_REGISTRIES_LIST,
  CHECK_TYPE_STATUS_LIST, CHECK_TYPES_TYPE_LIST, CITIZENSHIP_TYPE_LIST,
  PROCEDURE_TYPE_LIST, USER_TYPE_LIST,
} from '../../../configs';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';

export default function CheckTypesForm(props) {
  const {
    close = () => {},
    loadData = () => {},
    current = {},
    isEdit = false,
  } = props;
  const dispatch = useDispatch();
  const {
    control,
    getValues,
    formState: { errors },
    setError,
    setFocus,
  } = useForm({
    mode: 'onChange',
    defaultValues: isEdit ? current : {},
  });

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Сохранение формы шаблона запроса', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    const action = isEdit ? editCheckTypesById : createCheckTypes;
    dispatch(action({ ...values, id: current.id }))
      .then(() => {
        loadData();
        close();
        successNotification('Сохранение формы шаблона запроса', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение формы МАИС ЭГУ', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const DTO = new CheckTypesDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dialog
      className="application-denied-dialog"
      onClose={close}
      open
    >
      <DialogTitle header={isEdit ? 'Редактирование шаблона запроса' : 'Создание шаблона запроса'} title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.source}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.service_name}
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={MultipleSelectInput}
            dtoObject={attributes.apply_to_registries}
            options={CHECK_TYPE_APPLY_TO_REGISTRIES_LIST}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            options={CHECK_TYPE_STATUS_LIST}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.type}
            options={CHECK_TYPES_TYPE_LIST}
            withLabel
            variant="material"
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={MultipleSelectInput}
            dtoObject={attributes.apply_to_procedures}
            withLabel
            variant="material"
            options={PROCEDURE_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={MultipleSelectInput}
            dtoObject={attributes.apply_to_legal_entity_types}
            withLabel
            variant="material"
            options={USER_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={MultipleSelectInput}
            dtoObject={attributes.apply_to_citizenship}
            withLabel
            variant="material"
            options={CITIZENSHIP_TYPE_LIST}
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
          <Button className="hff-clear-show" type="submit" onClick={handleSave}>Сохранить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
